import * as CONST  from '../constants';
import headerimg from '../images/header-image-01.png';

const defaultState = {
    cart: {},
    finalCart: {},
    donation: null,
    donationError: false,
    disableNav: [false, true, true, true, true],
    navBarActiveIndex: null,
    alertMsg: {},
    heroTitle: "",
    heroImage: "",
    heroMobileImage: ""
};

export function shoppingCartReducer(state = defaultState, action) {
    switch (action.type) {
    case CONST.DISABLE_NAV:
        return {...state, disableNav: action.payload};
    case CONST.SET_ALERT_MSG:
        return {...state, alertMsg: action.payload};
    case CONST.SET_SHOPPING_CART:
        return {...state, cart: action.payload};
    case CONST.SET_FINAL_CART:
        return {...state, finalCart: action.payload};
    case CONST.SET_NAV_INDEX:
        return {...state, navBarActiveIndex: action.payload};
    case CONST.SET_HERO:
        return {
            ...state,
            heroTitle: action.payload.title || "",
            heroImage: action.payload.image || headerimg,
            heroMobileImage: action.payload.mobileImage || headerimg
        };
    case CONST.SET_DONATION:
        return {...state, donation: action.payload};
    case CONST.SET_DONATION_ERROR:
        return {...state, donationError: action.payload};
    default:
        return state;
    }
}
